module.exports = __webpack_public_path__ + "static/media/Create.c4ca3880.png";